import type {ReactNode} from "react";
import {Link} from "react-router-dom";

import {cn} from "@/lib/utils";

export const RESIDENT_HOME_PATH = "/home";

type ResidentBrandHomeLinkProps = {
  isResident: boolean;
  className?: string;
  children: ReactNode;
};

export function ResidentBrandHomeLink({
  isResident,
  className,
  children,
}: ResidentBrandHomeLinkProps) {
  if (!isResident) {
    return <div className={className}>{children}</div>;
  }

  return (
    <Link
      to={RESIDENT_HOME_PATH}
      className={cn(
        "rounded-md outline-hidden ring-ring transition-colors hover:bg-accent focus-visible:ring-2",
        className,
      )}
      aria-label="Go to home"
    >
      {children}
    </Link>
  );
}
